import gql from 'graphql-tag';

export default gql`
mutation createGroup($obj: CreateGroupInput!) {
  createGroup(object: $obj) {
    group_id
  }
}
`;
